<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align: center;">Illustrations by Chloe Pouteau, who was extremely helpful in taking minimal artistic direction and creating illustrations that fit the needs of every poem for which she did an illustration.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7f273239